/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：670
 */

module.exports = "https://creation.codemao.cn/coconut/web/1.22.0-0/" + "static/media/cloudDict.811724d4.svg"
